import styled, { CSSObject } from 'styled-components';

import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';
import DefaultPopup from '../defaultPopup';

import { wideBreakpoints } from './../../layouts/wideContainer/index';

export interface IBasePopupCustomStyles {
    topWrapper?: CSSObject,
    contentWrapper?: CSSObject,
    contentInner?: CSSObject,
}

export const SDefaultPopup = styled(DefaultPopup)`
    padding: 32px 0 32px 32px !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 16px 0 16px 16px !important;
        width: calc(100% - 48px) !important;
    }
`;

export const TopWrapper = styled.div<{ customStyles?: IBasePopupCustomStyles }>`
    display: block;
    padding-right: 32px;
    padding-bottom: 16px;
    ${p => p?.customStyles?.topWrapper || ''};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-right: 16px;
    }
`;

export const ContentWrapper = styled.div<{ customStyles?: IBasePopupCustomStyles }>`
    width: 100%;
    height: 100%;
    padding-right: 8px;
    ${p => p?.customStyles?.contentWrapper || ''};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding-right: 0;
    }
`;

export const ContentInner = styled.div<{ customStyles?: IBasePopupCustomStyles }>`
    height: 100%;
    width: 100%;
    padding-right: 17px;
    ${p => p?.customStyles?.contentInner || ''};
  
    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: -16px;
        padding-right: 10px;
    }
`;

export const Title = styled.h2`
    ${FONTS.H3}
    width: calc(100% - 42px);
    margin: 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
        margin-top: 10px;
        margin-left: 8px;
    }
`;

export const Text = styled.p`
    ${FONTS.S};
    margin: 8px 0 16px 0;
    color: ${COLORS.TextInfo};

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 12px;
    }
`;
